import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment/moment";
import store from '../state/store';



export default class Api{

    constructor() {
        this.env = {
          //  dev: 'http://127.0.0.1:8000',
           dev: 'https://demo-v35.api.klispay.africa',
           // dev: 'https://bingerville.api.nta-ci.com',
            //dev: 'https://api-gesco.mata-groupe.com',
            //dev: 'https://api.etsboubacardiarra.com',
        }


        this.version = [3];

        this.call = axios.create({
            baseURL: this.env.dev+"/api/v"+this.version[0],
        });

        this.call.interceptors.request.use(
            (config) => {
                const token = store.state.jwt_token;
                if (token) {
                    // Ajout du token dans l'en-tête Authorization
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );
        this.call.interceptors.response.use(
            response => response, // Directly return successful responses.
            async error => {
                // ----------------------------------------------------
                // NOUVELLE VÉRIFICATION CLÉ
                // Si la requête échouée était déjà la requête de rafraîchissement,
                // on évite de la relancer.
                const originalRequest = error.config;
                if (originalRequest.url.endsWith('/token/refresh')) {
                    // L'échec du refresh token est un échec d'authentification final.
                    console.error('Refresh token failed. Redirecting to login.');

                    // Appeler la méthode de déconnexion/redirection de votre classe

                    return Promise.reject(error);
                }
                // ----------------------------------------------------


                // Ancienne logique
                console.log(store.state.refresh_token)
                if (error.response.status === 401) {
                    await this.refreshAuthToken()

                    // Après le rafraîchissement, rejouer la requête initiale qui a échoué (étape manquante)
                    originalRequest.headers['Authorization'] = 'Bearer ' + store.state.jwt_token;
                    return this.call(originalRequest);
                }
                return Promise.reject(error); // For all other errors, return the error as is.
            }
        );
        this.callLogin = axios.create({
            baseURL: this.env.dev+"/api",
        });

        this.logoUrl = this.env.prod+"/uploads/logos/"

    }
    async  refreshAuthToken() {
        const refreshToken = store.state.refresh_token

        if (!refreshToken) {
            // Si le token n'est même pas là, déconnexion immédiate
            throw new Error('No refresh token available')
        }

        try {
            // NOTE : Utiliser this.callLogin pour appeler /api/token/refresh
            // car this.call a un baseURL de /api/v3
            const res = await axios.post(`${this.env.dev+"/api/v"+this.version[0]}/token/refresh`, {refresh_token: refreshToken},{
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }
            });
            // ... (logique de succès inchangée) ...

            const newAccessToken = res.data.token
            const newRefreshToken = res.data.refreshToken

            localStorage.setItem('jwt_token', newAccessToken);
            await store.dispatch("setJwtToken", newAccessToken)

            localStorage.setItem('refresh_token', newRefreshToken);
            await store.dispatch("setRefreshToken", newRefreshToken)

            return newAccessToken

        } catch (error) {
            // Si la requête de rafraîchissement échoue (401, token invalide, etc.)
            console.error('Erreur lors du rafraîchissement du token:', error);
            throw error
        }
    }


    // Méthode pour ajouter les en-têtes d'autorisation
    async getAuthHeaders() {
        const token = store.state.jwt_token;
        if (token) {
            return {
                'Authorization': `Bearer ${token}`
            };
        }
        return {};
    }

    // Méthode de rafraîchissement du token
    async refreshToken() {
        const refreshToken = store.state.refresh_token;
        if (!refreshToken) {
            return null;
        }

        try {
            const response = await axios.post(
                `${this.env.dev}/token/refresh`,
                { refresh_token: refreshToken },
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response.status === 200) {
                const data = response.data;
                localStorage.setItem('jwt_token', data.token);
                await store.dispatch("setJwtToken", data.token)
                if (data.refresh_token) {
                    localStorage.setItem('refresh_token', data.refreshToken);
                    await store.dispatch("setRefreshToken", data.refreshToken)

                }
                return data;
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    }
    // Méthode de connexion
    async login(credentials) {
        try {
            //console.log(this.token)
            const response = await this.callLogin.post("login", credentials,{
                headers: {

                }
            })
            const data = response.data;
            console.log(data)

            if (data.token) {
                localStorage.setItem('jwt_token', data.token);
                await store.dispatch("setJwtToken", data.token)

                localStorage.setItem('refresh_token', data.refreshToken);
                await store.dispatch("setRefreshToken", data.refreshToken)

                // Le reste de votre logique de connexion
                return data;
            }
            return false;
        } catch (e) {
            return false;
        }
    }
    async register(credentials) {
        try {
            //console.log(this.token)
            const response = await this.callLogin.post("register", credentials,{
                headers: {
                }
            });

            const data = response.data;
            if(data.id){
                await this.login({username: credentials.email, password: credentials.password})
                return data;
            }
            return data;
        } catch (e) {
            return false;
        }
    }
    formattedNumber(number) {
        if (number != null)
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return 0;
    }
    formatDate(date, format){
        return moment(date).lang('fr').format(format);

    }
    async listing(url, fields, orderBy, sortOrder, itemPerPage, currentPage) {

        try {


            let list;
            if(fields ==null){
                 list = await this.call.get(url, {
                     headers: {
                     }
                 })
            }else {
                let query = '';
                if(url.includes('?'))
                    query = url+'&orderBy=' + orderBy + '&sortOrder=' + sortOrder + '&itemsperpage=' + itemPerPage + '&page=' + currentPage;
                else
                    query = url+'?orderBy=' + orderBy + '&sortOrder=' + sortOrder + '&itemsperpage=' + itemPerPage + '&page=' + currentPage;

                fields.forEach(function (element) {
                    let tableau = null;
                    switch (element.operator) {
                        case 'eq':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'not eq':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'gt':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'gte':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'lt':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'lte':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'like':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'not like':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'is null':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator;
                            break;
                        case 'is not null':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator;
                            break;
                        case 'in':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'not in':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'between':
                            tableau = element.value.split('et');
                            console.log(tableau[0]);
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + tableau[0].trim() + '&filter[' + element.colonne + '][y]=' + tableau[1].trim()+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            //console.log(query);

                            break;
                        case 'dateBetween':
                            // tableau = element.value.split('au');
                            //console.log(tableau[0]);
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.x.trim() + '&filter[' + element.colonne + '][y]=' + element.y.trim()+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            //console.log(query);

                            break;


                    }
                });
                //console.log(query);

                 list = await this.call.get(query, {
                     headers: {
                     }
                 })

            }

            //console.log(list.data);
            return list.data;
        }catch (e) {
            this.toast();

        }
    }
    async delete(url) {

        try {
            const response = await this.call.delete(url,{
                headers: {
                    'Content-Type': 'application/merge-patch+json'
                }
            })

            if (response.status === 204){
                return true;
            }
            if (response.status !== 500){
                return false;
            }


        }catch (e) {
            this.toast()

        }
    }
    confirmDete() {
        Swal.fire({
            title: "Etes-vous sûr ?",
            text: "Vous ne pourrez plus recuper les informations",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.value) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
            }
        });
    }
    success(message) {
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 1500,
        });
    }
    async get(url) {

        try {


            let list;

            //console.log(query);

            list = await  this.call.get(url, {
                headers: {
                }
            })

            //console.log(list.data);
            return list.data;
        }catch (e) {
            this.toast();

        }
    }
    async post(url, data) {

        try {
            const response = await this.call.post(url, data,{
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }
            })
            //console.log(this.token)

            if (response.status === 201 || response.status === 200){
                return response.data;
            }else
                this.toast()



        }catch (e) {
            this.toast()

        }
    }
    async upload(url, data) {

        try {

            //console.log(this.token)
            const response = await this.call.post(url, data,{
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'multipart/form-data'
                }
            })
            if (response.status === 201 || response.status === 200){
                return response.data;
            }else
                this.toast()



        }catch (e) {
            this.toast()

        }
    }

    async put(url, data) {

        try {
            const response = await this.call.put(url, data,{
                headers: {
                    // 'Content-Type': 'application/merge-patch+json'
                }
            })

            if (response.status === 200){


                return response.data;
            }
        }catch (e) {
            this.toast()

        }
    }

    toast (){
        Swal.fire({
            title: "Oops...",
            text: "Une erreur s'est produite !",
            icon: "error",
            confirmButtonClass: "btn btn-primary w-xs mt-2",
            buttonsStyling: false,

            showCloseButton: true,
        });
    }

    // Méthode de déconnexion
    logout() {
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('currentUser');
        Swal.fire({
            title: "Session expirée",
            text: "Veuillez vous reconnecter.",
            icon: "error",
        }).then(() => {
            // Redirection vers la page de connexion, à adapter selon votre routeur
            window.location.href = '/login';
        });
    }
}